import React, { Component } from 'react';
import classes from "./TextPersonSpecies.module.css";

export default class TextPersonSpecies extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>
                
                <p className="text-anal">The Gender of the Villagers can also be analyzed to indicate how the players expect certain Species type to be either male or female. There are notably nore females who are Cats, Rabbits and Squirrels. While there are less males that are Sheep. This indicates that most men do not relate to being sheepish in personality.</p>
        
                <p className="text-anal">As noted about Data Science, there are gaps in information. This is most obvious when the data is charted. There is no information about how many female Bulls and Lions, male Cows, and no numbers on Kangeroos at all. There could be two or more possible conclusions of this gap in data: (1) The Animal Crossing Fandom has collected a large but incomplete dataset on this game. (2) There are possible no female Bulls or Lions and so no data (instead of the number 0) was entered in this chart.</p> 

            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/